import{a as R}from"./chunk.O4IVVUYK.js";import{b as H}from"./chunk.EG3M3KIY.js";import{b as W}from"./chunk.6QCLN5MH.js";import{b as M}from"./chunk.W3YHHWSB.js";import{b as z,d as T}from"./chunk.PBO6R6GJ.js";import{d as O}from"./chunk.Y6IZEKYX.js";import{b as E}from"./chunk.CUOPQL3Y.js";import{a as B}from"./chunk.2AIXLGYE.js";import{a as f}from"./chunk.NFEB7TIJ.js";import{a as _}from"./chunk.XPINZPW5.js";import{a as A}from"./chunk.65JZXZ5X.js";import{d as C}from"./chunk.DQ7YBHX4.js";import{c as l}from"./chunk.NWIV65VP.js";import{property as n,query as P,queryAsync as F,state as c}from"lit/decorators.js";import{html as o}from"lit/static-html.js";import{classMap as b}from"lit/directives/class-map.js";import{styleMap as I}from"lit/directives/style-map.js";import{ifDefined as K}from"lit/directives/if-defined.js";import{css as L}from"lit";var q=L`
  ${B}
  ${R}

  :host {
    display: block;
  }

  :host,
  .data-grid,
  .data-grid__responsive-table {
    height: 100%;
  }

  .data-grid__responsive-table {
    overflow: auto;
  }

  .data-grid--no-scroll .data-grid__responsive-table {
    overflow: visible;
  }

  .data-grid__controls {
    margin-bottom: var(--he-spacing-small);
  }

  .data-grid__table {
    min-width: 100%;
  }

  .data-grid__loading {
    border-radius: 4px;
    height: 16px;
    width: 100%;
  }

  .data-grid__sort {
    background-color: transparent;
    color: var(--he-type-primary);
    outline-offset: var(--he-spacing-2x-small);
    cursor: pointer;
    display: flex;
    align-items: baseline;
  }

  .data-grid__sort:hover .data-grid__sort-icon {
    visibility: visible;
  }

  .data-grid__sort-icon {
    font-size: var(--he-font-size-small);
    margin-inline-start: var(--he-spacing-x-small);
    visibility: hidden;
  }

  .data-grid__sort-icon--sorted {
    visibility: visible;
  }

  .data-grid__selector {
    margin: 0px;
    margin-inline-end: var(--he-spacing-medium);
  }

  .data-grid__selector:focus-visible {
    outline: solid var(--he-focus-ring-width) var(--he-form-control-toggle-focus-ring-color);
    outline-offset: 2px;
  }

  .data-grid__selector::part(label) {
    width: 0;
    margin-inline-end: calc(var(--he-spacing-x-small) * -1);
  }

  .data-grid__tooltip-icon {
    margin-inline-start: var(--he-spacing-2x-small);
    color: var(--he-accent-foreground-rest);
  }

  .data-grid__tooltip-icon:focus-visible {
    outline: solid var(--he-focus-ring-width) var(--he-form-control-toggle-focus-ring-color);
    outline-offset: 2px;
  }

  .data-grid__table-header__content {
    display: inline-flex;
    align-items: center;
    position: relative;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
  }

  .data-grid__column__content {
    font-weight: var(--he-font-weight-semibold);
  }

  .data-grid__row-header__content {
    display: flex;
    align-content: start;
  }

  .data-grid__table-header {
    font-weight: unset !important;
  }

  .data-grid__table-header__slot::slotted(*) {
    margin-top: -0.5em;
    margin-inline-start: var(--he-spacing-2x-small);
  }

  .data-grid__line-clamp {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .data-grid__no-records__wrapper {
    min-height: 150px;
    padding: var(--he-spacing-medium);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .data-grid__bulk-select {
    margin-inline-start: calc(var(--he-spacing-small) * -1);
    margin-inline-end: var(--he-spacing-2x-small);
  }

  .data-grid__bulk-select__trigger {
    background-color: transparent;
    color: var(--he-type-primary);
  }

  .data-grid__bulk-select__icon {
    padding: var(--he-spacing-2x-small);
    font-size: var(--he-font-size-medium);
  }

  .data-grid__bulk-select__trigger:focus-visible {
    outline: solid var(--he-focus-ring-width) var(--he-form-control-toggle-focus-ring-color);
    outline-offset: 2px;
  }

  .data-grid__bulk-select__options::part(content) {
    font-weight: var(--he-font-weight-normal);
  }

  .data-grid__bulk-select__spacer {
    width: var(--he-spacing-medium);
  }

  .data-grid__radio-select__spacer {
    width: 20px;
    margin-inline-end: var(--he-spacing-medium);
  }

  /* High contrast */
  @media screen and (forced-colors: active) {
    .data-grid__sort,
    .data-grid__bulk-select__trigger {
      background-color: ${f.ButtonFace};
      color: ${f.ButtonText};
    }

    [class*='icon'] {
      fill: ${f.ButtonText};
    }
  }
`;var s=class extends A{constructor(){super();this.scope=C(this);this.fixedHeading=!1;this.fixedColumn=!1;this.loading=!1;this.sortAscending=!0;this.selectAll=!1;this.noScroll=!1;this.fixedPlacement=!1;this.columns=[];this.rows=[];this.bulkSelectOptions=[];this.columnCount=0;this.isMultiSelect=!1;this.isSingleSelect=!1;this.loadingTemplate=()=>o`
    <${this.scope.tag("skeleton")}
      class="data-grid__loading"
      shape="rect"
      shimmer
    >
    </${this.scope.tag("skeleton")}>
  `;this.headingTemplate=(e,t)=>{var m,h,u,p,g;let i=o`
      <${this.scope.tag("icon")}
        name="${this.sortAscending?"sortup":"sortdown"}"
        class=${b({"data-grid__sort-icon":!0,"data-grid__sort-icon--sorted":this.sortBy===(e==null?void 0:e.field)})}
      ></${this.scope.tag("icon")}>
    `,a=o`
      <button class="data-grid__sort" @click=${r=>this.handleSort(e==null?void 0:e.field,r)}>
        ${e==null?void 0:e.content} ${i}
      </button>
    `,d=o`
      <${this.scope.tag("checkbox")}
        class="data-grid__selector data-grid__select-all"
        @keyup=${r=>this.handleSelectAll(r)}
        @he-change=${r=>this.handleSelectAll(r)}
      >
        <span class="visually-hidden">${this.localize.term("select_all")}</span>
      </${this.scope.tag("checkbox")}>
    `,v=o`
      <${this.scope.tag("dropdown")} class="data-grid__bulk-select" ?fixed-placement=${this.fixedPlacement}>
        <button slot="trigger" class="data-grid__bulk-select__trigger" >
          <${this.scope.tag("icon")}
            name="chevrondown"
            label="${this.localize.term("more_options")}"
            class="data-grid__bulk-select__icon"
          >
            </${this.scope.tag("icon")}>
        </button>
        <${this.scope.tag("menu")}>
          ${this.bulkSelectOptions.map(r=>o`
              <${this.scope.tag("menu-item")}
                class="data-grid__bulk-select__options"
                @click=${()=>this.handleBulkSelect(r.name)}
              >
                ${r.content}
              </${this.scope.tag("menu-item")}>
            `)}
        </${this.scope.tag("menu")}>
      </${this.scope.tag("dropdown")}>
    `;return o`
      <th
        role="columnheader"
        class=${b({"data-grid__table-header":!0,"data-grid__table-header--sortable":!!(e==null?void 0:e.sortable)})}
        style=${I({display:((m=e==null?void 0:e.display)==null?void 0:m.hideAt)&&e.display.hideAt>=this.componentWidth?"none":"table-cell",width:(h=e==null?void 0:e.display)==null?void 0:h.width,"min-width":(u=e==null?void 0:e.display)==null?void 0:u.minWidth,"max-width":(p=e==null?void 0:e.display)==null?void 0:p.maxWidth})}
      >
        ${this.loading&&!e?this.loadingTemplate():o`
              <span class="data-grid__table-header__content">
                ${t===0&&this.isSingleSelect?o`<span class="data-grid__radio-select__spacer"></span>`:""}
                ${t===0&&this.isMultiSelect?d:""}
                ${t===0&&this.isMultiSelect&&((g=this.bulkSelectOptions)==null?void 0:g.length)?v:""}
                <span class="data-grid__column__content"> ${e.sortable?a:e.content} </span>
                <slot name="${e.field}-column-header" class="data-grid__table-header__slot"></slot>
              </span>
            `}
      </th>
    `};this.cellTemplate=(e,t,i)=>{var g,r,$,w,k,S,x;let a=o`
      <${this.scope.tag("checkbox")}
        id="${t==null?void 0:t.id}"
        class="data-grid__selector data-grid__select-row"
        aria-label="${this.localize.term("select_row")}"
        ?checked="${t==null?void 0:t.selected}"
        ?disabled=${t==null?void 0:t.disabled}
        @he-change="${y=>this.handleSelectRow(t,y)}"
      >
        <span class="visually-hidden">${this.localize.term("select_row")}</span>
      </${this.scope.tag("checkbox")}>
      ${this.select&&((g=this.bulkSelectOptions)==null?void 0:g.length)?o`<span class="data-grid__bulk-select__spacer"></span>`:""}
    `,d=o`
      <${this.scope.tag("radio")}
        id="${t==null?void 0:t.id}"
        class="data-grid__selector data-grid__select-row"
        aria-label="${this.localize.term("select_row")}"
        ?checked="${t==null?void 0:t.selected}"
        ?disabled=${t==null?void 0:t.disabled}
        @click="${y=>this.handleSelectRow(t,y)}">
      </${this.scope.tag("radio")}>
    `,v=(t==null?void 0:t.cells[e==null?void 0:e.field])||"",m=b({"data-grid__cell-content":!0,"data-grid__line-clamp":!!((r=e==null?void 0:e.display)==null?void 0:r.lineClamp)}),h=`display: ${(($=e==null?void 0:e.display)==null?void 0:$.hideAt)&&((w=e==null?void 0:e.display)==null?void 0:w.hideAt)>=this.componentWidth?"none":"table-cell"}`,u=I({"-webkit-line-clamp":(S=(k=e==null?void 0:e.display)==null?void 0:k.lineClamp)==null?void 0:S.toString(),"white-space":((x=e==null?void 0:e.display)==null?void 0:x.noWrap)?"nowrap":"normal"}),p=o`<span class="${m}" style="${u}">
      <slot name="${e==null?void 0:e.field}-${t==null?void 0:t.id}">${v}</slot>
    </span>`;return i===0?o`<th scope="row" role="rowheader" class="data-grid__row-header" style="${h}">
          <span class="data-grid__row-header__content">
            ${this.select==="multiple"&&!this.loading?a:""}
            ${this.select==="single"&&!this.loading?d:""}
            ${this.loading?this.loadingTemplate():p}
          </span>
        </th>`:o`
          <td class="data-grid__cell" style=${h}>${this.loading?this.loadingTemplate():p}</td>
        `};this.rowTemplate=e=>o`
    <tr
      role="row"
      class="data-grid__row"
      aria-selected="${K(this.select&&!this.loading?e.selected===!0:void 0)}"
    >
      ${this.columns.map((t,i)=>this.cellTemplate(t,e,i))}
    </tr>
  `;this.scope.registerComponent(E,M,W,H,O,z,T)}get selectedRows(){return this.rows.filter(e=>e.selected)}async handleSelectAllChange(){if(this.isMultiSelect){let e=await this.selectAllCheckbox;if(!e)return;e.checked=this.selectAll,this.updateSelectedRowsBasedOnSelectAll()}}handleSelectChange(){this.isSingleSelect=this.select==="single",this.isMultiSelect=this.select==="multiple"}handleColumnsChange(){this.initResizeObserver()}async handleRowsChange(){var e;!this.select||(this.updateSelectedRowsBasedOnSelectAll(),(e=this.shadowRoot)==null||e.querySelectorAll(".data-grid__select-row").forEach((t,i)=>{let a=this.rows[i];(a==null?void 0:a.disabled)!==!0&&(t.checked=(a==null?void 0:a.selected)||!1,this.toggleGridRowSelection(t))}))}disconnectedCallback(){this.resizeObserver&&(this.resizeObserver.unobserve(this),this.resizeObserver.disconnect()),super.disconnectedCallback()}updated(e){this.isSingleSelect&&setTimeout(()=>{var t,i;return(i=(t=this.shadowRoot)==null?void 0:t.querySelectorAll(".data-grid__selector"))==null?void 0:i.forEach(a=>a.tabIndex=0)})}handleSort(e,t){e===this.sortBy?this.sortAscending=!this.sortAscending:(this.sortBy=e,this.sortAscending=!0),this.setSortAttributes(t.target),this.emitSort()}handleBulkSelect(e){this.emit("he-bulk-select",{detail:e}),this.bulkSelectDropdown.hide()}async handleSelectAll(e){let t=e.key;if(t&&t!==" ")return;let i=e.target;await this.updateComplete,this.selectAll=i.checked,this.toggleRows(i.checked),this.emit("he-select-all-change",{detail:i.checked})}async handleSelectRow(e,t){let i=t.target;if(await this.updateComplete,this.isMultiSelect||this.toggleRowById(e.id),this.isMultiSelect){let a=this.rows.find(d=>d.id===e.id);a.selected=i.checked,this.toggleGridRowSelection(i)}this.emit("he-row-select-change",{detail:e})}updateSelectedRowsBasedOnSelectAll(){this.selectAll&&(this.rows=this.rows.map(e=>(e.disabled||(e.selected=!0),e)))}setSortAttributes(e){var t,i,a;this.tableHead.querySelectorAll("th").forEach(d=>d.removeAttribute("aria-sort")),(a=(i=(t=e.parentElement)==null?void 0:t.parentElement)==null?void 0:i.parentElement)==null||a.setAttribute("aria-sort",this.sortAscending?"ascending":"descending")}emitSort(){let e={sortBy:this.sortBy,isAscending:this.sortAscending};this.emit("he-sort",{detail:e})}toggleRows(e){this.toggleRowData(e),this.toggleRowCheckboxes(e)}toggleRowData(e){this.rows=this.rows.map(t=>(t.disabled||(t.selected=e),t))}toggleRowById(e){this.rows=this.rows.map(t=>(t.disabled||(t.selected=t.id===e),t))}toggleRowCheckboxes(e){var t;(t=this.shadowRoot)==null||t.querySelectorAll(".data-grid__select-row").forEach(i=>{i.disabled||(i.checked=e,this.toggleGridRowSelection(i))})}toggleGridRowSelection(e){var t,i,a;(a=(i=(t=e.parentElement)==null?void 0:t.parentElement)==null?void 0:i.parentElement)==null||a.setAttribute("aria-selected",e.checked.toString())}initResizeObserver(){var t;this.columnCount=(t=this.columns)==null?void 0:t.length,!!(this.columns&&this.columns.some(i=>{var a;return(a=i==null?void 0:i.display)==null?void 0:a.hideAt}))&&(this.resizeObserver=new ResizeObserver(()=>{this.componentWidth=this.clientWidth,this.columnCount=this.columns.filter(i=>{var a;return!((a=i==null?void 0:i.display)==null?void 0:a.hideAt)||this.componentWidth>i.display.hideAt}).length}),this.resizeObserver.observe(this))}render(){return o`
      <div
        class=${b({"data-grid":!0,"data-grid--fixed-heading":this.fixedHeading,"data-grid--fixed-column":this.fixedColumn,"data-grid--no-scroll":this.noScroll})}
      >
        <div class="data-grid__controls">
          <slot name="data-grid-controls"></slot>
        </div>

        <div class="data-grid__responsive-table he-responsive-table">
          <table
            role="grid"
            aria-rowcount="${this.rows.length}"
            aria-colcount="${this.columnCount}"
            aria-busy="${this.loading}"
            aria-multiselectable="${this.isMultiSelect}"
            class=${b({"data-grid__table":!0,"he-table":!0,"he-table--hover":!0,"he-table--fixed-heading":this.fixedHeading,"he-table--fixed-column":this.fixedColumn})}
          >
            <thead role="rowgroup" part="table-head">
              <tr role="row">
                ${this.columns.map((e,t)=>this.headingTemplate(e,t))}
              </tr>
            </thead>
            <tbody role="rowgroup" part="table-body">
              ${this.rows.map(e=>this.rowTemplate(e))}
            </tbody>
          </table>
        </div>

        <div class="data-grid__no-records" aria-live="polite">
          ${!this.rows||this.rows.length===0?o`
                <div class="data-grid__no-records__wrapper" part="no-records">
                  <slot name="no-records"></slot>
                </div>
              `:""}
        </div>

        <div class="data-grid__pagination">
          <slot name="pagination"></slot>
        </div>
      </div>
    `}};s.styles=q,s.baseName="data-grid",s.reactEvents={onHeSort:new CustomEvent("he-sort"),onHeRowSelectChange:new CustomEvent("he-row-select-change"),onHeSelectAllChange:new CustomEvent("he-select-all-change"),onHeBulkSelect:new CustomEvent("he-bulk-select")},l([n({attribute:"fixed-heading",type:Boolean})],s.prototype,"fixedHeading",2),l([n({attribute:"fixed-column",type:Boolean})],s.prototype,"fixedColumn",2),l([n({type:Boolean})],s.prototype,"loading",2),l([n()],s.prototype,"select",2),l([n({attribute:"sort-by"})],s.prototype,"sortBy",2),l([n({attribute:"sort-ascending",type:Boolean})],s.prototype,"sortAscending",2),l([n({attribute:"select-all",type:Boolean,reflect:!0})],s.prototype,"selectAll",2),l([n({attribute:"no-scroll",type:Boolean,reflect:!0})],s.prototype,"noScroll",2),l([n({type:Boolean,attribute:"fixed-placement",reflect:!0})],s.prototype,"fixedPlacement",2),l([c()],s.prototype,"columns",2),l([c()],s.prototype,"rows",2),l([c()],s.prototype,"bulkSelectOptions",2),l([c()],s.prototype,"componentWidth",2),l([c()],s.prototype,"columnCount",2),l([c()],s.prototype,"isMultiSelect",2),l([c()],s.prototype,"isSingleSelect",2),l([P("thead")],s.prototype,"tableHead",2),l([F(".data-grid__select-all")],s.prototype,"selectAllCheckbox",2),l([P(".data-grid__bulk-select")],s.prototype,"bulkSelectDropdown",2),l([_("selectAll",{waitUntilFirstUpdate:!0})],s.prototype,"handleSelectAllChange",1),l([_("select")],s.prototype,"handleSelectChange",1),l([_("columns")],s.prototype,"handleColumnsChange",1),l([_("rows")],s.prototype,"handleRowsChange",1);var pe=s;export{s as a,pe as b};
